<template>
    <div class="simple-navbar-wrapper">
        <div class="simple-navbar py-3 h-16 w-full gap-5 flex items-center justify-between">
            <div class="app-navbar__logo flex items-center justify-center">
                <RouterLink
                    :to="mainPageUrl"
                    class="outline-none"
                >
                    <img
                        :src="String(getLogo)"
                        alt="Logo"
                        class="h-9 w-auto max-w-48 object-contain"
                    >
                </RouterLink>
            </div>
            <div
                class="flex-grow flex items-center gap-3"
            >
                <div class="w-full flex justify-between items-center">
                    <div class="nav-left-block">
                        <slot name="left-actions" />
                    </div>
                    <div class="nav-right-block">
                        <slot name="right-actions" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { activeLayoutLogo } from '@/composables/globalData/useLayouts'
import { useRoute } from 'vue-router/composables'
const route = useRoute()

/* Computed */
const getLogo = computed(() => {
    return activeLayoutLogo.value
})

const mainPageUrl = computed(() => {
    const token = route.query.token
    return {
        path: '/',
        query: { token }
    }
})
</script>

<style lang="scss">
    .simple-navbar {
        &-wrapper {
            @apply px-3 lg:px-8 xl:px-10 hidden md:block border-b border-ui-lines;
            background: var(--dashboardHeaderBgColor-color);
            z-index: var(--index-navbar);
        }
    }
</style>
